"use strict";

import angular from "angular";

import template from "./one-million-impacts-card-component.component.html";
import "./one-million-impacts-card-component.component.scss";

export class OneMillionImpactsCardComponent {
    rotateProgressDegStyle = `translate3d(-50%, -50%, 0)  rotate(0deg)`;
    percentageProgress = 0;

    levels = {
        Bronze: {
            label: "Bronze",
            maxImpacts: 11,
            classColor: "bronze",
            total: 0
        },
        Prata: {
            label: "Prata",
            maxImpacts: 101,
            classColor: "silver",
            total: 0
        },
        Ouro: {
            label: "Ouro",
            maxImpacts: 1001,
            classColor: "gold",
            total: 0
        },
        Embaixador: {
            label: "Embaixador",
            maxImpacts: 1300,
            classColor: "ambassador",
            total: 0
        }
    };

    currentImpact = { total: 0 };
    constructor() {}

    $onInit() {
        this._setProgressCircle();
    }

    $onChanges() {
        this._setProgressCircle();
    }

    _setProgressCircle() {
        if (!this.levels[this.impacts?.currentImpactLevel?.status]) {
            this.currentImpact = this.levels["Bronze"];
        } else {
            this.currentImpact = this.levels[
                this.impacts?.currentImpactLevel?.status
            ];

            this.currentImpact.total =
                this.impacts?.currentImpactLevel?.total || 0;

            this.levels.maxImpacts = this.currentImpact.total || 0;
        }

        this._setRorateProgressCircle(this.currentImpact.maxImpacts ?? 0);
    }

    _setRorateProgressCircle(maxImpacts) {
        const percentage = (this.currentImpact.total / maxImpacts) * 100;
        const degRotation = (percentage / 100) * 360;

        this.rotateProgressDegStyle = `translate3d(-50%, -50%, 0)  rotate(${degRotation}deg)`;
        this.percentageProgress = percentage;
    }
}

const name = "oneMillionImpactsCardComponent";
const def = {
    bindings: { impacts: "<" },
    controller: OneMillionImpactsCardComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
